import OBTDialog from './OBTDialog';

export default OBTDialog;